export default "__VITE_ASSET__DsjI3A1x__"